<cdx-slotted-modal (close)="close()" [size]="size" [mobileFullHeight]="true">
	<h3 modal-header i18n="@@directToBootInformation-mainHeading">
		<span>What is Direct To Boot?</span>
	</h3>
	<div modal-content>
		<p i18n="@@directToBootInformation-headingSummary">
			Direct to Boot is a pick up service offered at select stores. Your order will be brought to your car and placed
			directly into your boot by one of our team.
		</p>
		<section class="howDoesItWork">
			<h4 i18n="@@directToBootInformation-howDoesItWork">How does it work?</h4>
		</section>
		<section class="instructions">
			<div class="instructions-info">
				<cdx-svg-icon name="sms" fill="dark"></cdx-svg-icon>
				<div>
					<h5 i18n="@@directToBootInformation-followInstructionsInSmsHeading">Follow the instructions in the SMS</h5>
					<p i18n="@@directToBootInformation-followInstructionsInSmsHeadingContent">
						Sent when your order is ready for pick up.
					</p>
				</div>
			</div>
			<div class="instructions-info">
				<cdx-svg-icon name="direct-to-boot-front" fill="dark"></cdx-svg-icon>
				<div>
					<h5 i18n="@@directToBootInformation-parkingHeading">Park in one of the pick up bays</h5>
					<p i18n="@@directToBootInformation-parkingContent">Follow the on-site Pick up signage.</p>
				</div>
			</div>
			<div class="instructions-info">
				<cdx-svg-icon name="location-pin" fill="dark"></cdx-svg-icon>
				<div>
					<h5 i18n="@@directToBootInformation-letUsKnowHeading">Let us know which bay you’ve parked in</h5>
					<p i18n="@@directToBootInformation-letUsKnowContent">Via the SMS web link.</p>
				</div>
			</div>
			<div i18n="@@directToBootInformation-infoContent">
				<h4>Keeping you and our team safe</h4>
				After arriving, please ensure that:
				<ul>
					<li>Your car is turned off</li>
					<li>Your handbrake is on</li>
					<li>Your boot is easily accessible</li>
					<li>If possible to do so, please reverse in</li>
				</ul>
			</div>
		</section>
	</div>
</cdx-slotted-modal>
